import { createAction, handleActions } from 'redux-actions'

const openNotesModal = createAction('SCREENS/SUBBIES/SUB_VALUATIONS/OPEN_NOTES_MODAL')
const closeNotesModal = createAction('SCREENS/SUBBIES/SUB_VALUATIONS/CLOSE_NOTES_MODAL')

const defaultState = {
  show: false,
}

const reducer = handleActions(
  {
    [openNotesModal]: (state, { payload }) => ({ ...payload, show: true }),
    [closeNotesModal]: () => defaultState,
  },
  defaultState,
)

export { openNotesModal, closeNotesModal, reducer }
